import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { getTooltipStyles, convertData } from './Graph.services';
import { mainColor } from '../../constants/theme';

const labels = [
  { title: 'Total', color: mainColor.colorAdditional, key: 'total' },
  { title: 'Paiement en Ligne', color: mainColor.colorBlue, key: 'stripe' },
  { title: 'TPE', color: mainColor.colorYellow, key: 'tpe' },
  { title: 'Espèces', color: mainColor.colorRed, key: 'cash' },
  { title: 'Ticket restaurant', color: mainColor.colorBrown, key: 'ticket_resto' },
  { title: 'Comptoir', color: mainColor.secondaryColor, key: 'counter' }
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload) {
    return (
      <Paper className='p-2'>
        {_.map(payload, p => {
          return (
            <div className='custom-tooltip'>
              <p className='label' style={{ color: p.color }}>{`${p.name}: ${p.value} €`}</p>
            </div>
          );
        })}
      </Paper>
    );
  }

  return null;
};

class Graph extends PureComponent {
  render() {
    const { data, rtl } = this.props;
    const filtredData= _.filter(_.keys(data), elm => elm!=='shopResults').reduce((obj, cur) => ({ ...obj, [cur]: data[cur] }), {});
    return (
      <div dir='ltr' className='col-12 pl-0 pr-0'>
        <ResponsiveContainer height={300} className='dashboard__area'>
          <AreaChart data={convertData(filtredData)} margin={{ top: 20, left: -15, bottom: 20 }}>
            <XAxis dataKey='date' tickLine={false} reversed={rtl === 'rtl'} />
            <YAxis unit='€' tickLine={false} orientation={rtl === 'rtl' ? 'right' : 'left'} />
            <Tooltip
              content={<CustomTooltip />}
              {...getTooltipStyles('theme-light', 'defaultItems')}
            />
            <Legend />
            <CartesianGrid />
            {_.map(labels, paymentType => {
              return (
                <Area
                  name={paymentType.title}
                  type='monotone'
                  dataKey={paymentType.key}
                  fill={paymentType.color}
                  stroke={paymentType.color}
                  fillOpacity={0.2}
                />
              );
            })}
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ finances }) => {
  const { selectedGraph, selectedEntity } = finances;
  return {
    data: finances[selectedEntity],
    selectedEntity,
    selectedGraph
  };
};

export default connect(mapStateToProps, {})(Graph);
